import _ from 'lodash';

import { NAMES as ORGANIZATION_ACTIONS } from '../../actions/organizations';

export const organizations = (state = {}, action) => {
  switch (action.type) {
    case ORGANIZATION_ACTIONS.ORGANIZATIONS_GET_SUCCESS:
      return _.keyBy(action.payload, 'id');
    case ORGANIZATION_ACTIONS.ORGANIZATION_CREATE_SUCCESS:
      return {
        ...state,
        [action.payload.id]: action.payload,
      };
    default:
      return state;
  }
};
